import { StrictMode } from 'react'
import './index.css'
import { createRoot } from 'react-dom/client'
import App from './App'
import { SyncProvider } from '@/shared/services/sync/SyncProvider'
import { AuthListener } from '@/features/auth/components/AuthListener'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

const queryClient = new QueryClient()

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <QueryClientProvider client={queryClient}>
            <AuthListener>
                <SyncProvider>
                    <App />
                </SyncProvider>
            </AuthListener>
        </QueryClientProvider>
    </StrictMode>
)

